import { z } from "zod";

export const webhookDeliveriesQuerySchema = z
	.object({
		cursor: z.string().optional(),
		limit: z.coerce.number().int().min(1).max(50).optional(),
	})
	.strict();

export type WebhookDeliveriesQuery = z.infer<typeof webhookDeliveriesQuerySchema>;
